<template>
  <section
    class="technology-text-box"
    :class="{ active: active }"
    :style="{
      bottom: textBox.position.bottom + '%',
      left: textBox.position.left + '%'
    }"
  >
    <div class="technology-text-box__exit-area">
      <div class="technology-text-box__exit-area__technology-text-box-button" @click="endAnimation">
        <p class="font technology-text-box__exit-area__technology-text-box-button__exit">EXIT</p>
        <img
          class="technology-text-box__exit-area__technology-text-box-button__icon"
          :src="exitIcon"
          alt
        />
      </div>
    </div>
    <div class="technology-text-box__text-area">
      <div class="technology-text-box__text-area__wrapper">
        <div v-if="textBox.icon" class="technology-text-box__text-area__wrapper__icon">
          <img :src="textBox.icon" />
        </div>
        <div
          class="font technology-text-box__text-area__wrapper__text"
          :class="{ 'full-width': !textBox.icon }"
        >
          <p id="textBoxText" v-html="textBox.text"></p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import nextArrowIcon from "@/assets/text-box-accents/next-arrow.svg";
import exitIcon from "@/assets/text-box-accents/exit-icon.svg";
import goButton from "@/assets/text-box-accents/go-button.svg";

import { mapState, mapMutations, mapActions } from "vuex";
export default {
  name: "technology-text-box",
  props: [
    "textBox",
    "onClose",
    "next",
    "updated",
    "continueAnimation",
    "lastTextBox",
    "previousProgress",
    "animationProgress",
    "active",
    "boxToClear",
    "boxToShow",
    "revealIconsOnTimeOut",
    "clearIconRevealTimeoutsAndRevealAll"
  ],
  data() {
    return {
      nextArrowIcon,
      exitIcon,
      i: 0,
      typeTimeOuts: [],
      progressMotion: this.previousProgress
    };
  },
  computed: {
    ...mapState({
      voiceOver: state => state.audio.voiceOver,
      currentAnimationName: state => state.analytics.currentAnimationName
    })
  },
  methods: {
    ...mapMutations([
      "updateWaitProgress",
      "updateTotalWaitTime",
      "setVoiceOver",
      "updateStopTimeIdx",
      "setTechnologyLandscapeTextBox",
      "getBenefitCardTextBox",
      "setBenefitCardTextBox",
      "updateShowAmbientAnimations"
    ]),
    ...mapActions(["getBenefitCardTextBox"]),
    endAnimation() {
      this.$ga.event({
        eventCategory: "Macro Animation",
        eventAction: "Canceled Selection",
        eventLabel: "CANCELED_TECHNOLOGY_TEXTBOX: " + this.currentAnimationName,
        eventValue: 1
      });
      this.updateShowAmbientAnimations(true);
      if (this.voiceOver) {
        this.voiceOver.pause();
        this.setVoiceOver(undefined);
      }
      this.setTechnologyLandscapeTextBox(undefined);
      this.updateWaitProgress(0);
      this.updateStopTimeIdx(-1);
      this.onClose(true);
    },
    onNext() {
      this.$ga.event({
        eventCategory: "Macro Animation",
        eventAction: "Skipped Selection",
        eventLabel: "SKIPPED_TECHNOLOGY_TEXTBOX: " + this.currentAnimationName,
        eventValue: 1
      });
      if (this.voiceOver) {
        this.voiceOver.pause();
        this.clearVoiceOver();
      }
      this.clearVoiceOver();
      this.clearIconRevealTimeoutsAndRevealAll();
      this.getBenefitCardTextBox();
    },
    clearDelayTimeout() {
      for (let timeout of this.typeTimeOuts) {
        clearTimeout(timeout);
      }
    },
    voiceOverEnded() {
      this.clearVoiceOver();
      this.setTechnologyLandscapeTextBox(undefined);
      this.getBenefitCardTextBox();
    },
    createVoiceOver(audio) {
      return new Promise((resolve, reject) => {
        if (this.voiceOver === undefined) {
          this.setVoiceOver(new Audio("/voice-overs/" + audio));
          this.voiceOver.addEventListener("ended", this.voiceOverEnded);
        }
        resolve();
      });
    },
    clearVoiceOver() {
      if (this.voiceOver) {
        this.voiceOver.removeEventListener("ended", this.voiceOverEnded);
      }
      this.setVoiceOver(undefined);
    }
  },
  mounted() {
    this.clearVoiceOver();
    if (this.textBox) {
      this.createVoiceOver(this.textBox.voiceOver).then(() => {
        setTimeout(() => {
          this.revealIconsOnTimeOut();
          this.voiceOver.play();
        }, 2000);
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import "../styles/_vars";
.technology-text-box {
  opacity: 1;
  position: absolute;
  z-index: 200;
  width: 10.5vw;
  height: 4vw;
  transition: opacity $button-duration cubic-bezier(0.22, 1, 0.36, 1),
    transform $button-duration cubic-bezier(0.22, 1, 0.36, 1);
  &__exit-area {
    position: relative;
    display: flex;
    justify-content: flex-end;
    width: 100%;
    height: 15%;
    &__technology-text-box-button {
      cursor: pointer;
      height: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: flex-end;
      align-content: center;
      align-items: center;
      &__exit {
        color: $color-white;
        font-size: 0.4vw;
        margin-right: 0.3vw;
      }
      &__icon {
        height: 0.55vw;
        width: 0.55vw;
        margin-right: 0.3vw;
      }
    }
  }
  &__text-area {
    margin-top: 2%;
    position: relative;
    width: 100%;
    height: 80%;
    background-color: $color-black-transparent;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: center;
    align-items: center;
    &__wrapper {
      background-color: $color-white;
      position: relative;
      width: 90%;
      height: 70%;
      padding: 2%;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: flex-start;
      align-content: center;
      align-items: center;
      &__icon {
        width: 16%;
        height: 100%;
        margin-top: 2%;
        margin-left: 1%;
        img {
          width: 100%;
          height: 100%;
        }
      }
      &__text {
        padding: 0.3% 0;
        width: 81%;
        height: 100%;
        line-height: 0.4vw;
        font-size: 0.3vw;
        margin-left: 2%;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-start;
        align-content: center;
        align-items: center;
      }
    }
  }
  &__progress-bar {
    position: relative;

    width: 100%;
    height: 2%;
    min-height: 2px;
    background-color: $color-blue;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-content: center;
    align-items: center;
    &__animation-progress {
      z-index: 10;
      width: 80%;
      height: 100%;
      &__progress {
        height: 100%;
        width: 100%;
        background-color: $color-lime;
        transform-origin: left;
        transform: scaleX(0);
      }
    }
    &__pause-progress {
      z-index: 10;
      width: 20%;
      height: 100%;
      &__progress {
        height: 100%;
        width: 100%;
        background-color: $color-lime;
        transform-origin: left;
        transform: scaleX(0);
      }
    }
  }
  &__next-area {
    height: 19%;
    display: flex;
    justify-content: flex-start;
    background-color: $color-black-transparent;
    &__technology-text-box-button {
      cursor: pointer;
      height: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: flex-start;
      align-content: center;
      align-items: center;
      &__next {
        color: $color-lime-bright;
        font-size: 0.4vw;
        margin-left: 0.3vw;
      }
    }
  }
  &__pointer-area {
    position: relative;
    width: 100%;
    height: 10%;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
  }
  &__go-button-area-wrapper {
    width: 100%;
    height: 10%;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-end;
    align-content: center;
    align-items: center;
    &__go-button-area {
      position: absolute;
      width: 5vw;
      height: 1vw;
      transform: translateX(0);
      cursor: pointer;
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: center;
      align-content: center;
      align-items: center;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}

.arrow-down {
  width: 0;
  height: 0;
  border-left: 0.5vw solid transparent;
  border-right: 0.5vw solid transparent;
  border-top: 0.4vw solid $color-black-transparent;
}
.arrow-right {
  justify-content: flex-end;
}

.arrow-right-margin {
  margin-right: 0.5vw;
}
.active {
  z-index: 200;
}
.full-width {
  width: 100%;
}
</style>
